import React from 'react';
// Data
import { linkButtonArray } from '../../utils/data/LinksData';
import { CompanyName } from '../../utils/Constants';
import { CONTACT_PAGE_URL } from '../../utils/Routes';

function LinksPageMainContainer() {
  return (
    <main role='main' className='pt-28 full_shadow_black_invert'>
      <article className='grid gap-4 text-center px-6 sm:py-4 lg:py-8'>
        <h3 className='text-2xl lg:text-4xl font-semibold font-newsweekly tracking-widest'>
          Spoil & Treat Me!
        </h3>
        <h4>
          Interested in being my sub in person?
        </h4>
        <a href={CONTACT_PAGE_URL}>Contact {CompanyName} Now</a>
      </article>
      <section className='grid justify-center mx-auto py-8 gap-y-4 w-fit'>
        {linkButtonArray.map((btn, index) => (
          <a
            key={index}
            href={btn.link}
            className={`flex items-center gap-3 cursor-pointer bg-colour3 border-2 border-solid border-colour4 hover:bg-colour1/30 neon_button px-6 py-2 w-full text-center rounded text-colour5 hover:text-colour4 ${
              !btn.link ? 'hidden' : ''
            }`}
            aria-label={`Visit ${btn.text}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            <span className='text-2xl'>{btn.icon}</span>
            <div className='text-center w-full'>
              <span>{btn.text}</span>
            </div>
          </a>
        ))}
      </section>
    </main>
  );
}

export default LinksPageMainContainer;
